import * as React from 'react'
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SystemAlerts from 'src/component/SystemAlerts';
import System from 'src/helper/system';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import { Pagination } from 'src/reusable/global';
import Helper from 'src/support/Helper';
import NoResultContent from '../NoResultContent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';
import Constants from 'src/support/Constants';

let c = System.getParams();
const NewProductInformationTabContent = (props) => {
    const [list, setList] = useState({});
    const { homePageAllTabs } = Constants;

    const [firstServerCall, setFirstServerCall] = useState(true);
    const [{ }, { get_home_page_content }] = useHomePageContentStore();
    const [listObj, setListObj] = useState({ pageCount: 0, page: 1, limit: 20, sortBy: 'Relevance' });
    const [searchParams] = useSearchParams();
    const [total, setTotal] = useState(0);
    const [__check] = useAxiosIndicatorCheck();

    useEffect(() => {
        const getList = async () => {
            await fetchAPiCall(firstServerCall);
            await setFirstServerCall(false);
        };
        getList();
    }, []);

    useEffect(() => {
        const getList = async () => {
            setTimeout(async () => {
                await fetchAPiCall();
            }, 500);
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.page]);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall(firstServerCall)
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.limit]);

    const defaultPageActive = async () => {
        setListObj({ ...listObj, page: 1 })
    }

    const handlePageClick = async (data) => {
        let here_page = 0
        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        Helper.scrollTop();
    };

    const setPageLimit = async (event) => {
        await setListObj({ ...listObj, limit: event.target.value });
    };


    const fetchAPiCall = async (
        defaultStart = false) => {
        __set('NEW_PRODUCT_INFORMATION_API_CALL')
        let search_keyword = searchParams.get('search')
        const data = await get_home_page_content({
            pageNumber: defaultStart ? 1 : listObj.page,
            pageSize: listObj.limit,
            orderBy: listObj.sortBy,
            searchTerm: search_keyword,
            contentType: homePageAllTabs.NPI.contentType,
        });

        if (data[homePageAllTabs.NPI.contentType].webContentView) {
            const total = data[homePageAllTabs.NPI.contentType].totalCount;
            setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
            setTotal(total);
            setList(data[homePageAllTabs.NPI.contentType].webContentView);
        }
        __remove("NEW_PRODUCT_INFORMATION_API_CALL");
    };


    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall();
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.sortBy])


    const onFilter = (e) => {
        setListObj({ ...listObj, sortBy: e.target.value })
    }
    return (
        <>
            <div className="filter-records">
                <span>Showing {total} content results for <b>"{c.search}"</b></span>
            </div>
            <div className='new-content-wrapper'>
                <div className='bs5 container-fluid maxw-auto'>
                    <div>
                        <SystemAlerts />
                    </div>

                    <div className='bs5 row mt-3'>
                        <div className='col-lg-9 tab-data'>
                            <div className='all-content'>
                                <div className='all-content-header'>
                                    <div className="bs5 row mt-1">
                                        <div className="col-auto">
                                            <div className='font-oswald font-light font-30'>New Product Information
                                            </div>
                                        </div>
                                        {list !== undefined && list !== null && Object.entries(list).length > 0 &&
                                            <div className="col-auto ms-auto align-self-end">
                                                <div className='d-flex align-items-center'>
                                                    <label className='mb-0 me-3'>Sort By:</label>
                                                    <div className="selectbox">
                                                        <select className="form-control form-control-xs w210" onChange={(e) => onFilter(e)}>
                                                            <option value=''>Relevance </option>
                                                            <option value='NameASC'>Name - A to Z</option>
                                                            <option value='NameDESC'>Name - Z to A</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <hr />
                                <div className='position-relative'>
                                    <div>
                                        {__check(['NEW_PRODUCT_INFORMATION_API_CALL'], { overlay: true }).render}
                                    </div>
                                    <div className='all-content-body'>
                                        {list !== undefined && list !== null && Object.entries(list).length > 0 &&
                                            list.map((v, i) => (
                                                <div className='all-content-body-item' key={i}>
                                                    <div className='font-16 text-blue2 font-bold mb-1'><a href={v['url']} target='_blank'> {v['name']}</a></div>
                                                    <div className='ellipses'
                                                        title={v['shortDescription']}>
                                                        {v['shortDescription']}
                                                    </div>
                                                    <hr />
                                                </div>
                                            ))
                                        }
                                        {firstServerCall === false && (list === undefined || list === null || Object.entries(list).length === 0) &&
                                            searchParams.get('search') !== undefined && searchParams.get('search') !== null && searchParams.get('search') !== '' &&
                                            <NoResultContent message={'No Results Found for <b>"' + searchParams.get('search') + '"</b>'} />
                                        }
                                    </div>
                                    {list !== undefined && list !== null && Object.entries(list).length > 0 &&
                                        <div className="pagination-row">
                                            <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 tab-sidebar'>
                            <div className='m-b-20' id="espotImg" >
                            </div>
                            <div className='newsletter m-b-20'>
                                <div className='newsletter-title font-24 font-bold font-apercu'>Newsletter</div>
                                <p className='m-b-15 text-black'>Subscribe for online delivery</p>
                                <a className='bs5 btn btn-primary w135'>Sign up now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewProductInformationTabContent